import { Routes, Route } from 'react-router-dom';
import PrivateRoute from '../components/common/PrivateRoute';
import LinksConfig from '../components/Products/FoodstationLinks/pages/admin/LinksConfig';

// Rotas internas de configuração do restaurante.
// A visão pública (`/links/:slug`) é registrada diretamente no App.js.
const FoodstationLinksRoutes = () => (
  <Routes>
    <Route
      index
      element={
        <PrivateRoute product="linkpage">
          <LinksConfig />
        </PrivateRoute>
      }
    />
  </Routes>
);

export default FoodstationLinksRoutes;
